export const getBrandingName = (
  enableHpControlHubAndHpAppStrings?: boolean
) => {
  return enableHpControlHubAndHpAppStrings ? 'HP App' : 'HP app'
}
